import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: 16,
    display: 'grid',
    borderRadius: 8,
    background: theme.palette.grey[100],
    margin: '8px 0px',
    gridTemplateColumns: '3.5fr 1fr'
  },
  left: { display: 'grid', gridTemplateColumns: '1fr 3fr' },
  right: {
    background: theme.palette.primary.light,
    height: 48,
    padding: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  price: {
    display: 'flex',
    height: 48,
    padding: 4,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  icon: { color: theme.palette.primary.main, fontSize: 18 },
  image: { width: '60px', height: '48px' },
  redText: { color: theme.palette.primary.main, fontWeight: 600, marginTop: 8 },
  text: {
    color: theme.palette.text.primary,
    fontWeight: 600
  }
}))
export default useStyles
